module.exports = __webpack_public_path__ + "6d9548338ba550f2446dd744eb2151.svg";